import { RefreshCw } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Button } from '@/components/ui/button';

interface ErrorStateProps {
  onRefresh: () => void;
}

export const ErrorState = ({ onRefresh }: ErrorStateProps) => {
  const { t } = useTranslation(['authenticated.settings']);

  return (
    <div className="flex items-start justify-between gap-4">
      <div className="flex flex-col gap-1">
        <h3 className="text-sm font-medium">
          {t('authenticated.settings:pages.integrations.refreshCard.error.title')}
        </h3>
        <p className="text-xs text-foreground">
          {t('authenticated.settings:pages.integrations.refreshCard.error.subtitle')}
        </p>
      </div>
      <div className="flex shrink-0 items-center gap-2">
        <Button size="sm" variant="default" onClick={onRefresh}>
          <RefreshCw className="h-4 w-4" />
          {t('authenticated.settings:pages.integrations.refreshCard.error.action')}
        </Button>
      </div>
    </div>
  );
};
